export const INITIAL_OPERATORS_REQUEST = "INITIAL_OPERATORS_REQUEST";
export const FETCH_OPERATORS_SUCCESS = "FETCH_OPERATORS_SUCCESS";
export const FINAL_OPERATORS_REQUEST = "FINAL_OPERATORS_REQUEST";
